import { combineReducers } from '@ngrx/store';
import * as fromModifyFormState from './location-specification-modify.reducer';
import * as fromJobsite from './jobsite-reducer/jobsite.reducer';
import * as fromProducts from './products-reducer/products.reducer';
import * as fromContactPerson from './contact-person.reducer';
import * as fromContactPersonRoles from './contact-person-roles.reducer';
import * as fromReceivingPersons from './receiving-persons.reducer';
import * as fromContracts from './contracts.reducer';
import * as fromAdditionalServices from './additional-services.reducer';
import * as fromUnits from './unit-reducer/units.reducer';
import * as fromNextWorkingDay from './next-working-day.reducer';
import * as fromDisabledDates from './load-holidays.reducer';
import * as fromPlants from './plants.reducer';

import * as fromAsyncValidationsModify from './async-validations-modify.reducer';

export const locationSpecificationKey = 'location-specification';

export interface ModifyOnlineOrderState {
  jobsite: fromJobsite.IJobsiteState;
  modifyFormState: fromModifyFormState.ModifyFormState;
  products: fromProducts.IProductsState;
  contracts: fromContracts.State;
  units: fromUnits.State;
  plants: fromPlants.State;
  contactPerson: fromContactPerson.State;
  contactPersonRoles: fromContactPersonRoles.State;
  receivingPersons: fromReceivingPersons.State;
  nextWorkingDay: fromNextWorkingDay.NextWorkingDayState;
  disabledDates: fromDisabledDates.HolidaysState;
  additionalServices: fromAdditionalServices.State;
  asyncValidationModify: fromAsyncValidationsModify.State;
}

export const reducers = combineReducers({
  jobsite: fromJobsite.jobsiteReducer,
  modifyFormState: fromModifyFormState.locationSpecificationFormReducer,
  products: fromProducts.productsReducer,
  contracts: fromContracts.reducer,
  units: fromUnits.reducer,
  plants: fromPlants.reducer,
  contactPerson: fromContactPerson.reducer,
  contactPersonRoles: fromContactPersonRoles.reducer,
  receivingPersons: fromReceivingPersons.reducer,
  nextWorkingDay: fromNextWorkingDay.reducer,
  disabledDates: fromDisabledDates.reducer,
  additionalServices: fromAdditionalServices.reducer,
  asyncValidationModify: fromAsyncValidationsModify.reducer,
});
